import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ETimerAppearanceSeparator } from '@common/enums';

@Component({
    selector: 'sp-timer-appearance',
    templateUrl: './timer-appearance.component.html',
    styleUrls: ['./timer-appearance.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule],
})
export class TimerAppearanceComponent {
    @Input() public separator: ETimerAppearanceSeparator;
    @Output() public changeEvent = new EventEmitter<ETimerAppearanceSeparator>();

    public ETimerAppearanceSeparator = ETimerAppearanceSeparator;
}
